import { Identifier } from '../../expr/ref/Identifier.js';

export class NamespaceIdent extends Identifier {}
